import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "antd";
import { InfoField, InfoTitle, ReviewTable, AllocationWrapper, AllocationBody, AllocationTableCol } from '../style';
import { formatAmount } from "../../../../../../../utils/commonUtil";
import formatter from "../../../../../../../utils/formatter";
import { replaceSelect } from "../../../../../../../utils/replacer"

function AllocationTable({
  allocations,
  Table = ReviewTable,
  allShares = false,
  allSharesAllPools = false,
}) {
  return (
  
    (allShares || allSharesAllPools) ? <AllocationWrapper>
     <Row>
        <AllocationTableCol span={12}><InfoField>Investment Options</InfoField></AllocationTableCol>
        <AllocationTableCol span={12}><InfoField>Units</InfoField></AllocationTableCol>
      </Row>
      {
        allocations.map(item => {
        return <AllocationBody key={item.name}>
            <AllocationTableCol span={12}><InfoTitle wrap>{replaceSelect(item.name)}</InfoTitle></AllocationTableCol>
            <AllocationTableCol span={12}><InfoTitle>{Number(item.units).toLocaleString()}</InfoTitle></AllocationTableCol>
          </AllocationBody>
        })
      }
      </AllocationWrapper> : <AllocationWrapper>
      <Row>
        <AllocationTableCol span={8}><InfoField wordBreakOnly={true}>Investment Options</InfoField></AllocationTableCol>
        <AllocationTableCol span={8}><InfoField wordBreakOnly={true}>Grant Percentage</InfoField></AllocationTableCol>
        <AllocationTableCol span={8}><InfoField wordBreakOnly={true}>Grant Amount</InfoField></AllocationTableCol>
      </Row>
      {
        allocations.map(item => {
        return <AllocationBody key={item.name}>
              <AllocationTableCol span={8}><InfoTitle wrap>{replaceSelect(item.name)}</InfoTitle></AllocationTableCol>
              <AllocationTableCol span={8}><InfoTitle>{formatter({value: item.grantPercentage,fieldSuffix:'PercentWDecimal'})}</InfoTitle></AllocationTableCol>
              <AllocationTableCol span={8}><InfoTitle>{formatAmount(item.grantAmount)}</InfoTitle></AllocationTableCol>
            </AllocationBody>
        })
      }
      
    </AllocationWrapper> 
  );
}

AllocationTable.propTypes = {
  allocations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      units: PropTypes.number,
      id: PropTypes.number,
      allShare: PropTypes.bool,
      grantAmount: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]),
      grantPercentage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]),
    })
  ),
  allShares: PropTypes.bool,
  allSharesAllPools: PropTypes.bool,
};

export default AllocationTable;
